var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          staticClass: "media-dialog",
        },
        [
          _c("div", { staticClass: "media-dialog__header" }, [
            _c(
              "button",
              {
                staticClass: "border-0 bg-transparent",
                on: { click: _vm.close },
              },
              [_c("i", { staticClass: "fas fa-2x fa-times" })]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "media-dialog__body text-left message-content" },
            [_vm._v("\n    " + _vm._s(_vm.getBody) + "\n  ")]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }